import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import withErrorContainer from '@zr/components/withErrorContainer';
import Message from '@zr/components/zrs/Message';

import {
  STRING_SCREEN_ADD_ANOTHER,
  STRING_SCREEN_NO_MORE,
  STRING_SCREEN_EDUCATION_ADD_ANOTHER_SUCCESS,
} from '@zr/jobseeker-public/apps/jobseeker-screens/labels';

import MinimalEducationFieldset from '@zr/jobseeker-public/apps/profile-form/components/Formik/MinimalEducationFieldset';

import {
  initialValues,
  minimalValidationSchema,
  useEducationFormikSubmit,
} from '@zr/jobseeker-public/apps/profile-form/utilities/educationFormUtilities';

import useAddAnotherRef from '@zr/jobseeker-public/apps/profile-form/utilities/useAddAnotherRef';
import areTextInputsEmpty from '@zr/jobseeker-public/apps/profile-form/utilities/areTextInputsEmpty';

import './ScreenViewWrapper.less';

export function Education({
  disabled, method, onAddAnother, onContinue, onError, onErrorClose, setIsLoading,
}) {
  const [addAnotherRef, setAddAnother, setNoMore] = useAddAnotherRef();

  const [numEducationsAdded, handleFormSubmit] = useEducationFormikSubmit(
    addAnotherRef,
    setIsLoading, {
      method,
      onAddAnother,
      onNoMore: onContinue,
      onError,
      onStartSubmit: onErrorClose,
    },
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
      validationSchema={minimalValidationSchema}
    >
      {(formikProps) => {
        const {
          handleSubmit, isSubmitting, values,
        } = formikProps;

        return (
          <form className="ScreenViewWrapper Education" onSubmit={handleSubmit}>
            {numEducationsAdded > 0 && (
              <Message type="success">{STRING_SCREEN_EDUCATION_ADD_ANOTHER_SUCCESS}</Message>
            )}
            <MinimalEducationFieldset
              disabled={disabled}
              formikProps={formikProps}
              numAdded={numEducationsAdded}
              enableRichText
            />
            <div className="button_wrapper">
              <button
                className="primary_button"
                onClick={setAddAnother}
                disabled={isSubmitting || disabled}
                type="submit"
              >
                {STRING_SCREEN_ADD_ANOTHER}
              </button>
              {/* if we require at least one education, force them to submit one */}
              {/* if they filled the 2nd or later entry at all, also validate/submit that */}
              {(!numEducationsAdded || !areTextInputsEmpty(values)) ? (
                <button
                  className="alt_button"
                  disabled={isSubmitting || disabled}
                  onClick={setNoMore}
                  type="submit"
                >
                  {STRING_SCREEN_NO_MORE}
                </button>
              ) : (
                // hard continue button, no form shenanigans
                <button
                  className="alt_button"
                  disabled={isSubmitting || disabled}
                  onClick={onContinue}
                  type="button"
                >
                  {STRING_SCREEN_NO_MORE}
                </button>
              )}
            </div>
          </form>
        );
      }}
    </Formik>
  );
}

Education.propTypes = {
  disabled: PropTypes.bool,
  method: PropTypes.string,
  onAddAnother: PropTypes.func,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onErrorClose: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func,
};

Education.defaultProps = {
  disabled: false,
  method: null,
  onAddAnother: () => {},
  setIsLoading: () => {},
};

export default withErrorContainer(Education);
